export default __webpack_public_path__ + "static/media/Lock.9b7b10e5.svg";